// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"4573":"b2e086cf","4644":"fe6df026","5678":"6cab3346","5863":"ea07109b"}[chunkId] + ".css";
};